module.exports = __webpack_public_path__ + "img/logo-picture.7cc5f5d3.png";